const TRANSFER_POLICY_MODULE = "0x2::transfer_policy";
const TRANSFER_POLICY_CREATED_EVENT = `${TRANSFER_POLICY_MODULE}::TransferPolicyCreated`;
const TRANSFER_POLICY_TYPE = `${TRANSFER_POLICY_MODULE}::TransferPolicy`;
const TRANSFER_POLICY_CAP_TYPE = `${TRANSFER_POLICY_MODULE}::TransferPolicyCap`;
const KIOSK_LOCK_RULE = "kiosk_lock_rule::Rule";
const ROYALTY_RULE = "royalty_rule::Rule";
export {
  KIOSK_LOCK_RULE,
  ROYALTY_RULE,
  TRANSFER_POLICY_CAP_TYPE,
  TRANSFER_POLICY_CREATED_EVENT,
  TRANSFER_POLICY_MODULE,
  TRANSFER_POLICY_TYPE
};
//# sourceMappingURL=transfer-policy.js.map
